module.exports = __webpack_public_path__ + "27b8a7251f674a93adf2d4b01d9a95d1.svg";